
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { head, isEmpty, choose, tryPick, tryFind, sortWith, singleton as singleton_1, reduce, append, contains, filter, ofArray, find, map, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { stringHash, compare, safeHash, int32ToString, createObj, structuralHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PropertyConfigurationId__get_unwrap, FormState__getValidation, PropertyConfigurationEnumValueId__get_unwrap, PropertyConfigurationId, PropertyConfigurationEnumValueId_Parse_Z721C83C5 } from "../Shared/Shared.js";
import { join, concat, split } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Select, MultiSelect } from "../Components/Select.js";
import { map as map_1, bind, defaultArg, unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { singleton, empty as empty_1, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { CustomProperty_$reflection, PropertyConfiguration_$reflection, CustomProperty } from "../Shared/PropertyConfiguration.js";
import { CurrencyInput, Input } from "../Components/Input.js";
import { TextArea } from "../Components/TextArea.js";
import { toString, parse as parse_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { DatePicker } from "../Components/DatePicker.js";
import { priceToString, tryParsePrice, toLocalISOString } from "../Common.js";
import { Checkbox } from "../Components/Checkbox.js";
import { LabeledValue } from "../Components/Text.js";
import { ofSeq, FSharpMap__TryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { sortAsc } from "../SharedComponents/NaturalOrder.js";
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ColumnDefinition$1, CellContent } from "./Table/Types.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";

function componentStateOf(formState) {
    if (formState.IsLoading) {
        return "disabled";
    }
    else {
        return "enabled";
    }
}

export function MultiEnumProperty(props) {
    let Label, Options;
    const t = useTranslation()[0];
    const requiredLabel = t("general.required");
    let enumValues;
    const matchValue = props.Property.Type;
    enumValues = ((matchValue.tag === 3) ? matchValue.fields[0] : empty());
    let value_2;
    const matchValue_1 = props.Value;
    value_2 = ((matchValue_1 == null) ? empty() : map((valueId_1) => ({
        label: find((enumValue) => equals(enumValue.Id, valueId_1), enumValues).Name,
        value: valueId_1,
    }), map(PropertyConfigurationEnumValueId_Parse_Z721C83C5, ofArray(split(matchValue_1.Value, [","], undefined, 0)))));
    return createElement(MultiSelect, (Label = (props.Property.Required ? concat(props.Property.Name, " (", requiredLabel, ...")") : props.Property.Name), (Options = filter((enumValue_2) => !contains(enumValue_2, value_2, {
        Equals: equals,
        GetHashCode: (x) => (structuralHash(x) | 0),
    }), map((value_3) => ({
        label: value_3.Name,
        value: value_3.Id,
    }), enumValues)), {
        ComponentState: componentStateOf(props.FormState),
        IsClearable: true,
        Label: unwrap(Label),
        NoOptionsMessage: "",
        OnChange: (option) => {
            let list_9;
            const option_2 = defaultArg(option, []);
            props.OnSetCustomProperties((list_9 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => {
                if (option_2.length === 0) {
                    return empty_1();
                }
                else {
                    return singleton(new CustomProperty(props.Property.Id.fields[0], reduce((e1, e2) => concat(e1, ",", ...e2), map((e) => PropertyConfigurationEnumValueId__get_unwrap(e.value), ofArray(option_2)))));
                }
            })), list_9)));
        },
        Options: Options,
        PlaceholderKey: "",
        TestId: props.TestId,
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id)))),
        Value: value_2,
    })));
}

export function StringProperty(props) {
    let Label, Value, matchValue, ValidationMessage;
    const t = useTranslation()[0];
    return createElement(Input, (Label = (props.Property.Required ? concat(props.Property.Name, " (", t("general.required"), ...")") : props.Property.Name), (Value = ((matchValue = props.Value, (matchValue == null) ? "" : matchValue.Value)), (ValidationMessage = FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id))), {
        ComponentState: componentStateOf(props.FormState),
        Label: unwrap(Label),
        OnChange: (value_1) => {
            let list_2;
            props.OnSetCustomProperties((list_2 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => singleton(new CustomProperty(props.Property.Id.fields[0], value_1)))), list_2)));
        },
        TestId: props.TestId,
        ValidationMessage: unwrap(ValidationMessage),
        Value: Value,
    }))));
}

export function TextAreaProperty(props) {
    let Label, Value, matchValue, ValidationMessage;
    const t = useTranslation()[0];
    return createElement(TextArea, (Label = (props.Property.Required ? concat(props.Property.Name, " (", t("general.required"), ...")") : props.Property.Name), (Value = ((matchValue = props.Value, (matchValue == null) ? "" : matchValue.Value)), (ValidationMessage = FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id))), {
        ComponentState: componentStateOf(props.FormState),
        Label: unwrap(Label),
        OnChange: (value_1) => {
            let list_2;
            props.OnSetCustomProperties((list_2 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => singleton(new CustomProperty(props.Property.Id.fields[0], value_1)))), list_2)));
        },
        TestId: props.TestId,
        ValidationMessage: unwrap(ValidationMessage),
        Value: Value,
    }))));
}

export function DateProperty(props) {
    let elems, children, Label;
    const t = useTranslation()[0];
    const requiredLabel = t("general.required");
    let value_1;
    const matchValue = props.Value;
    value_1 = ((matchValue != null) ? parse_1(matchValue.Value) : undefined);
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [(children = singleton_1(createElement(DatePicker, (Label = (props.Property.Required ? concat(props.Property.Name, " (", requiredLabel, ...")") : props.Property.Name), {
        ComponentState: componentStateOf(props.FormState),
        IsClearable: !props.Property.Required,
        Label: unwrap(Label),
        OnChange: (value_3) => {
            let list_2;
            props.OnSetCustomProperties((list_2 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => {
                if (value_3 != null) {
                    return singleton(new CustomProperty(props.Property.Id.fields[0], toLocalISOString(value_3)));
                }
                else {
                    return empty_1();
                }
            })), list_2)));
        },
        TestId: props.TestId,
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id)))),
        Value: unwrap(value_1),
    }))), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function BoolProperty(props) {
    let elems, IsChecked, matchValue;
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [Checkbox((IsChecked = ((matchValue = props.Value, (matchValue == null) ? false : (matchValue.Value === "true"))), {
        ComponentState: componentStateOf(props.FormState),
        IsChecked: IsChecked,
        Label: props.Property.Name,
        OnCheck: (value_2) => {
            let list_2;
            props.OnSetCustomProperties((list_2 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => singleton(new CustomProperty(props.Property.Id.fields[0], value_2 ? "true" : "false")))), list_2)));
        },
        TestId: props.TestId,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function CurrencyProperty(props) {
    let Label, Value;
    const t = useTranslation()[0];
    return createElement(CurrencyInput, (Label = (props.Property.Required ? concat(props.Property.Name, " (", t("general.required"), ...")") : props.Property.Name), (Value = bind((property) => tryParsePrice(property.Value), props.Value), {
        ComponentState: componentStateOf(props.FormState),
        Currency: props.Currency,
        Label: unwrap(Label),
        OnChange: (value) => {
            let list_2;
            props.OnSetCustomProperties((list_2 = filter((property_1) => !equals(new PropertyConfigurationId(parse(property_1.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => {
                if (value != null) {
                    return singleton(new CustomProperty(props.Property.Id.fields[0], int32ToString(value)));
                }
                else {
                    return empty_1();
                }
            })), list_2)));
        },
        TestId: "",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id)))),
        Value: unwrap(Value),
    })));
}

export function EnumProperty(props) {
    let Label, Options;
    const t = useTranslation()[0];
    let enumValues;
    const matchValue = props.Property.Type;
    enumValues = ((matchValue.tag === 2) ? matchValue.fields[0] : empty());
    const requiredLabel = t("general.required");
    let value_1;
    const matchValue_1 = props.Value;
    if (matchValue_1 == null) {
        value_1 = undefined;
    }
    else {
        const value = matchValue_1;
        value_1 = {
            label: find((enumValue) => equals(enumValue.Id, PropertyConfigurationEnumValueId_Parse_Z721C83C5(value.Value)), enumValues).Name,
            value: value.Id,
        };
    }
    return createElement(Select, (Label = (props.Property.Required ? concat(props.Property.Name, " (", requiredLabel, ...")") : props.Property.Name), (Options = map((value_2) => ({
        label: value_2.Name,
        value: PropertyConfigurationEnumValueId__get_unwrap(value_2.Id),
    }), enumValues), {
        ComponentState: componentStateOf(props.FormState),
        IsClearable: true,
        Label: unwrap(Label),
        NoOptionsMessage: "",
        OnChange: (option) => {
            let list_4;
            props.OnSetCustomProperties((list_4 = filter((property) => !equals(new PropertyConfigurationId(parse(property.Id)), props.Property.Id), props.CustomProperties), append(toList(delay(() => {
                if (option == null) {
                    return empty_1();
                }
                else {
                    return singleton(new CustomProperty(props.Property.Id.fields[0], option.value));
                }
            })), list_4)));
        },
        Options: Options,
        PlaceholderKey: "",
        TestId: props.TestId,
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("custom-property-", ...PropertyConfigurationId__get_unwrap(props.Property.Id)))),
        Value: unwrap(value_1),
    })));
}

export function View(props) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-3"])], (elems_1 = toList(delay(() => map((globalProperty) => {
        let elems;
        const matchValue = globalProperty.Type;
        switch (matchValue.tag) {
            case 3:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((property_1) => reduce((a, b) => concat(a, ", ", ...b), map((valueId_1) => find((enumValue_2) => equals(enumValue_2.Id, PropertyConfigurationEnumValueId_Parse_Z721C83C5(valueId_1)), matchValue.fields[0]).Name, ofArray(split(property_1.Value, [","], undefined, 0)))), FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), ""),
                });
            case 0:
            case 1:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((property_2) => property_2.Value, FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), ""),
                });
            case 4:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((property_3) => toString(parse_1(property_3.Value), "dd.MM.yyyy"), FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), ""),
                });
            case 5:
                return reactElement("div", createObj(singleton_1((elems = [reactElement("label", {
                    className: join(" ", ["mt-auto mb-auto mr-3"]),
                    children: globalProperty.Name,
                }), Checkbox({
                    ComponentState: "enabled",
                    IsChecked: defaultArg(map_1((property_4) => (property_4.Value === "true"), FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), false),
                    Label: "",
                    OnCheck: (value_9) => {
                    },
                    TestId: `custom-property-${globalProperty.Id}-bool-indicator`,
                })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
            case 6:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((property_5) => property_5.Value, FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), ""),
                });
            case 7:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((price) => {
                        const value_12 = price / 100;
                        return value_12.toString();
                    }, bind((property_6) => tryParsePrice(property_6.Value), FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id))), ""),
                });
            default:
                return LabeledValue({
                    Label: globalProperty.Name,
                    Value: defaultArg(map_1((property) => find((enumValue) => equals(enumValue.Id, PropertyConfigurationEnumValueId_Parse_Z721C83C5(property.Value)), matchValue.fields[0]).Name, FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)), ""),
                });
        }
    }, props.GlobalProperties))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Form(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = toList(delay(() => map((globalProperty) => {
        const matchValue = globalProperty.Type;
        switch (matchValue.tag) {
            case 3:
                return createElement(MultiEnumProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 0:
                return createElement(StringProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 1:
                return createElement(TextAreaProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 4:
                return createElement(DateProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 5:
                return createElement(BoolProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 6:
                return createElement(StringProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            case 7:
                return createElement(CurrencyProperty, {
                    Currency: props.Currency,
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
            default:
                return createElement(EnumProperty, {
                    CustomProperties: props.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperties: props.OnSetCustomProperties,
                    Property: globalProperty,
                    TestId: globalProperty.Name,
                    Value: unwrap(FSharpMap__TryFind(props.CustomPropertyValues, globalProperty.Id)),
                });
        }
    }, sortWith((globalPropertyA, globalPropertyB) => (sortAsc(globalPropertyA.Name, globalPropertyB.Name) | 0), props.GlobalProperties)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function NewInventoryCustomProperties(props) {
    let elems;
    const globalProperties = filter((configuration) => {
        const matchValue = configuration.Visibility;
        switch (matchValue.tag) {
            case 1:
                return contains(matchValue.fields[0], props.LabelIds, {
                    Equals: equals,
                    GetHashCode: (x) => (safeHash(x) | 0),
                });
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 12:
            case 11:
                return false;
            default:
                return true;
        }
    }, props.PropertyConfigurations);
    const customPropertyValues = ofSeq(map((customProperty) => [new PropertyConfigurationId(parse(customProperty.Id)), customProperty], props.CustomProperties), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(Form, {
        Currency: props.Currency,
        CustomProperties: props.CustomProperties,
        CustomPropertyValues: customPropertyValues,
        FormState: props.FormState,
        GlobalProperties: globalProperties,
        OnSetCustomProperties: props.OnSetCustomProperty,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function NewReceiverCustomProperties(props) {
    let elems;
    const globalProperties = filter((configuration) => equals(configuration.Visibility, props.PropertyConfigurationType), props.PropertyConfigurations);
    const customPropertyValues = ofSeq(map((customProperty) => [new PropertyConfigurationId(parse(customProperty.Id)), customProperty], props.CustomProperties), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(Form, {
        Currency: props.Currency,
        CustomProperties: props.CustomProperties,
        CustomPropertyValues: customPropertyValues,
        FormState: props.FormState,
        GlobalProperties: globalProperties,
        OnSetCustomProperties: props.OnSetCustomProperty,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

class Table_MatchedCustomProperty extends Record {
    constructor(Configuration, Property) {
        super();
        this.Configuration = Configuration;
        this.Property = Property;
    }
}

function Table_MatchedCustomProperty_$reflection() {
    return record_type("Widgets.CustomProperties.Table.MatchedCustomProperty", [], Table_MatchedCustomProperty, () => [["Configuration", PropertyConfiguration_$reflection()], ["Property", CustomProperty_$reflection()]]);
}

function Table_customPropertyColumnId(name) {
    return concat("custom-property-", ...name);
}

function Table_columnFilter(propertyConfiguration) {
    const matchValue = propertyConfiguration.Type;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 5:
            return "select";
        case 0:
        case 1:
        case 6:
        case 7:
            return "text";
        default:
            return "dateRange";
    }
}

function Table_columnType(propertyConfiguration) {
    const matchValue = propertyConfiguration.Type;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 5:
        case 0:
        case 1:
        case 6:
        case 7:
            return "text";
        default:
            return "date";
    }
}

function Table_tryFindConfiguration(sameNamedConfigurations, propertyConfigurationId) {
    return tryFind((propertyConfiguration) => equals(propertyConfiguration.Id, new PropertyConfigurationId(parse(propertyConfigurationId))), sameNamedConfigurations);
}

function Table_tryFindCustomProperty(sameNamedConfigurations, customProperties) {
    return tryPick((customProperty) => map_1((propertyConfiguration) => (new Table_MatchedCustomProperty(propertyConfiguration, customProperty)), Table_tryFindConfiguration(sameNamedConfigurations, customProperty.Id)), customProperties);
}

function Table_tryFindCustomPropertyValue(sameNamedConfigurations, customProperties) {
    return tryFind((customProperty) => (Table_tryFindConfiguration(sameNamedConfigurations, customProperty.PropertyConfigurationId) != null), customProperties);
}

function Table_enumValueName(enumValues, valueId) {
    return find((enumValue) => equals(enumValue.Id, PropertyConfigurationEnumValueId_Parse_Z721C83C5(valueId)), enumValues).Name;
}

function Table_yesNo(translate, value) {
    if (value) {
        return translate("general.yes");
    }
    else {
        return translate("general.no");
    }
}

function Table_textValue(translate, currency, matched) {
    const matchValue = matched.Configuration.Type;
    switch (matchValue.tag) {
        case 3:
            return join(", ", map((valueId) => Table_enumValueName(matchValue.fields[0], valueId), ofArray(split(matched.Property.Value, [","], undefined, 0))));
        case 5:
            return Table_yesNo(translate, matched.Property.Value === "true");
        case 7:
            return defaultArg(map_1((price) => priceToString(price, currency), tryParsePrice(matched.Property.Value)), "");
        case 0:
        case 1:
        case 6:
        case 4:
            return matched.Property.Value;
        default:
            return Table_enumValueName(matchValue.fields[0], matched.Property.Value);
    }
}

function Table_dateValue(matched) {
    const matchValue = matched.Configuration.Type;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 5:
        case 0:
        case 1:
        case 6:
        case 7:
            return undefined;
        default:
            return parse_1(matched.Property.Value);
    }
}

function Table_cellContent(translate, currency, columnConfiguration, matched) {
    const matchValue = columnConfiguration.Type;
    switch (matchValue.tag) {
        case 5:
            return new CellContent(0, [defaultArg(map_1((matched_2) => Table_textValue(translate, currency, matched_2), matched), translate("general.no"))]);
        case 2:
        case 3:
        case 0:
        case 1:
        case 6:
        case 7:
            return new CellContent(0, [defaultArg(map_1((matched_3) => Table_textValue(translate, currency, matched_3), matched), "")]);
        default:
            return new CellContent(8, [bind(Table_dateValue, matched)]);
    }
}

function Table_valueDtoTextValue(translate, customProperty) {
    const matchValue = customProperty.Type;
    switch (matchValue) {
        case "date":
            return defaultArg(map_1((value_2) => toString(value_2, "dd.MM.yyyy"), customProperty.DateValue), "");
        case "enum":
        case "multiEnum":
        case "text":
        case "textArea":
        case "url":
        case "currency":
            return defaultArg(customProperty.TextValue, "");
        default:
            return defaultArg(map_1((value) => Table_yesNo(translate, value), customProperty.BoolValue), translate("general.no"));
    }
}

function Table_valueDtoDateValue(customProperty) {
    const matchValue = customProperty.Type;
    switch (matchValue) {
        case "bool":
        case "enum":
        case "multiEnum":
        case "text":
        case "textArea":
        case "url":
        case "currency":
            return undefined;
        default:
            return customProperty.DateValue;
    }
}

function Table_valueDtoCellContent(translate, columnConfiguration, customProperty) {
    const matchValue = columnConfiguration.Type;
    switch (matchValue.tag) {
        case 5:
            return new CellContent(0, [defaultArg(map_1((customProperty_2) => Table_valueDtoTextValue(translate, customProperty_2), customProperty), translate("general.no"))]);
        case 2:
        case 3:
        case 0:
        case 1:
        case 6:
        case 7:
            return new CellContent(0, [defaultArg(map_1((customProperty_3) => Table_valueDtoTextValue(translate, customProperty_3), customProperty), "")]);
        default:
            return new CellContent(8, [bind(Table_valueDtoDateValue, customProperty)]);
    }
}

export function Table_customPropertyColumnDefinitions(propertyConfigurations, groupName, getCustomProperties, translate, currency) {
    return choose((tupledArg) => {
        const name = tupledArg[0];
        const sameNamedConfigurations = tupledArg[1];
        if (isEmpty(sameNamedConfigurations)) {
            return undefined;
        }
        else {
            const columnConfiguration = head(sameNamedConfigurations);
            return new ColumnDefinition$1(Table_customPropertyColumnId(name), groupName, name, (row) => Table_cellContent(translate, currency, columnConfiguration, Table_tryFindCustomProperty(sameNamedConfigurations, getCustomProperties(row))), Table_columnFilter(columnConfiguration), Table_columnType(columnConfiguration));
        }
    }, List_groupBy((_arg) => _arg.Name, propertyConfigurations, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
}

export function Table_customPropertyValueDtoColumnDefinitions(propertyConfigurations, groupName, getCustomProperties, translate) {
    return choose((tupledArg) => {
        const name = tupledArg[0];
        const sameNamedConfigurations = tupledArg[1];
        if (isEmpty(sameNamedConfigurations)) {
            return undefined;
        }
        else {
            const columnConfiguration = head(sameNamedConfigurations);
            return new ColumnDefinition$1(name, groupName, name, (row) => Table_valueDtoCellContent(translate, columnConfiguration, Table_tryFindCustomPropertyValue(sameNamedConfigurations, getCustomProperties(row))), Table_columnFilter(columnConfiguration), Table_columnType(columnConfiguration));
        }
    }, List_groupBy((_arg) => _arg.Name, propertyConfigurations, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
}

